import { render, staticRenderFns } from "./Positions.vue?vue&type=template&id=395d6094&scoped=true"
import script from "./Positions.vue?vue&type=script&lang=ts"
export * from "./Positions.vue?vue&type=script&lang=ts"
import style0 from "./Positions.vue?vue&type=style&index=0&id=395d6094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395d6094",
  null
  
)

export default component.exports